module.exports = __webpack_public_path__ + "files/be938ee43561c8876c0d67c30243ecdc.svg";